import { GeneralCargoOrderLocationItem } from '@tom-ui/planning/pages/GeneralCargo/Components/GeneralCargoOrderLocationItem'
import { generalCargoStockService, yardManagementHubConnection } from '@tom-ui/storage'
import { GeneralCargoOrderPlanningDto } from '@tom-ui/storage/app/api'
import { useCallback, useEffect, useState } from 'react'

export const useGeneralCargoOrderLocations = () => {
  const [reservationUpdate, setReservationUpdate] = useState<{
    orderId: number
    reservations: GeneralCargoOrderLocationItem[]
  } | null>(null)

  const handleGetOrderLocations = useCallback(async (orderIds: number[]) => {
    return await generalCargoStockService.getOrderLocations(orderIds)
  }, [])

  const handleGetOrderReservations = useCallback(async (orderIds: number[]) => {
    return await generalCargoStockService.getPlannedOccupanciesByOrderIds(orderIds)
  }, [])

  useEffect(() => {
    const handlePlanningUpserted = (planning: GeneralCargoOrderPlanningDto) => {
      const reservations: GeneralCargoOrderLocationItem[] = planning.planned.map(item => ({
        generalCargoLocation: item.generalCargoLocation,
        generalCargoArea: item.generalCargoArea,
        quantity: item.quantity,
      }))

      setReservationUpdate({
        orderId: planning.orderId,
        reservations,
      })
    }

    yardManagementHubConnection.onGeneralCargoOrderPlanningUpserted(handlePlanningUpserted)

    return () => {
      yardManagementHubConnection.offGeneralCargoOrderPlanningUpserted(handlePlanningUpserted)
    }
  }, [])

  return {
    reservationUpdate,
    handleGetOrderLocations,
    handleGetOrderReservations,
  }
}
